/**
 * @author EdenCha <eden@nurigo.net>
 */
import React, { useEffect, useRef } from 'react'
import withStyles from '@material-ui/core/styles/withStyles'

// libraries
import getComponentId from 'lib/getComponentId'

/**
 * 랜덤 이미지 생성
 */
let Component = ({ classes: cls, ...props }) => {
  const { seed = '1234', width = 200, height = 200 } = props
  const canvasRef = useRef(null)
  function seedToHash(str) {
    let hash = 0
    for (let i = 0; i < str.length; i++) {
      hash = (hash << 5) - hash + str.charCodeAt(i)
      hash |= 0
    }
    return Math.abs(hash)
  }

  function seededRandom(seed) {
    const x = Math.sin(seed++) * 10000
    return x - Math.floor(x)
  }

  function drawIdenticon() {
    const canvas = canvasRef.current
    const ctx = canvas.getContext('2d')
    const seedBase = seedToHash(seed)
    const size = 10 // 10x10 그리드
    const scale = 20 // 각 셀의 픽셀 크기

    ctx.clearRect(0, 0, canvas.width, canvas.height)

    const hue = Math.floor(seededRandom(seedBase) * 360)
    const sat = 70
    const light = 60
    const color = `hsl(${hue}, ${sat}%, ${light}%)`

    for (let row = 0; row < size; row++) {
      for (let col = 0; col < size / 2; col++) {
        const s = seedBase + row * size + col * 13
        const rand = seededRandom(s)
        const fill = rand > 0.5

        if (fill) {
          ctx.fillStyle = color
          ctx.fillRect(col * scale, row * scale, scale, scale)
          ctx.fillRect((size - 1 - col) * scale, row * scale, scale, scale) // 좌우 대칭
        }
      }
    }
  }
  useEffect(() => {
    drawIdenticon()
  }, [seed])
  return (
    <div
      data-compid={getComponentId('RandomSeedCanvasImage')}
      className={cls.root}
      style={{ width, height }}
    >
      <canvas
        id="canvas"
        className={cls.canvas}
        width="200"
        height="200"
        ref={canvasRef}
      ></canvas>
    </div>
  )
}

const commonStyles = theme => ({
  root: {},
  canvas: { width: '100%' }
})
Component = withStyles(commonStyles)(Component)

export default React.memo(Component)
